import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createSlots as _createSlots, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5ac1fb5c")

_pushScopeId("data-v-5ac1fb5c")
const _hoisted_1 = {
  type: "file",
  ref: "ele",
  accept: ".zip",
  style: {"display":"none"}
}
const _hoisted_2 = { class: "padding5px" }
const _hoisted_3 = { class: "padding5px" }
const _hoisted_4 = { class: "padding5px" }
const _hoisted_5 = { class: "padding5px" }
const _hoisted_6 = { class: "padding5px" }
const _hoisted_7 = { class: "result-title" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "el-icon-check" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = { class: "text-align-center" }
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = { class: "result-list" }
const _hoisted_13 = { class: "display-flex justify-content-space-between" }
const _hoisted_14 = { class: "font-size12px margin-right10px" }
const _hoisted_15 = { class: "full-upload" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "el-icon-loading" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_18 = { class: "font-size16px" }
const _hoisted_19 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_20 = { class: "font-size16px" }
const _hoisted_21 = {
  type: "file",
  ref: "file",
  accept: ".zip",
  style: {"display":"none"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_el_button = _resolveComponent("el-button")
  const _component_dialog_shell = _resolveComponent("dialog-shell")
  const _component_face_recognition_enrollment_dialog = _resolveComponent("face-recognition-enrollment-dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_cus_button, { onClick: _ctx.openImportFace }, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextImportFace), 1)
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode("input", _hoisted_1, null, 512),
    (_ctx.isShowTable)
      ? (_openBlock(), _createBlock(_component_dialog_shell, {
          key: 0,
          title: _ctx.$wordList.ProperAllTextImportFaceData,
          footerType: "customize",
          onClose: _ctx.closeDialog
        }, _createSlots({
          default: _withId(() => [
            (_ctx.isImporting)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createVNode("p", _hoisted_2, _toDisplayString(_ctx.$wordList.ImportFace100M), 1),
                  _createVNode("p", _hoisted_3, _toDisplayString(_ctx.$wordList.ImportFaceNo2), 1),
                  _createVNode("p", _hoisted_4, _toDisplayString(_ctx.$wordList.ImportFaceNo3), 1),
                  _createVNode("p", _hoisted_5, _toDisplayString(_ctx.ChangeWordList.ImportFace4), 1),
                  _createVNode("p", _hoisted_6, _toDisplayString(_ctx.$wordList.ImportFaceNo5), 1)
                ], 64))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _createVNode("p", _hoisted_7, [
                    _hoisted_8,
                    _createVNode("label", null, _toDisplayString(_ctx.$wordList.PropertyAllTextCompleted), 1)
                  ]),
                  _hoisted_9,
                  _createVNode("p", _hoisted_10, _toDisplayString(_ctx.$wordList.PropertyAllTextImportResult.format(_ctx.totalCount-_ctx.errorCount,_ctx.totalCount)), 1),
                  _hoisted_11,
                  _createVNode("ul", _hoisted_12, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.errorList, (item, index) => {
                      return (_openBlock(), _createBlock("li", {
                        class: "error",
                        key: index
                      }, [
                        _createVNode("label", null, _toDisplayString(item.fileName), 1),
                        _createVNode("label", null, _toDisplayString(_ctx.$wordList.PropertyAllTextFailed), 1)
                      ]))
                    }), 128)),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.successList, (item, index) => {
                      return (_openBlock(), _createBlock("li", {
                        class: "success",
                        key: index
                      }, [
                        _createVNode("label", null, _toDisplayString(item.fileName), 1),
                        _createVNode("label", null, _toDisplayString(_ctx.$wordList.PropertyAllTextSucceesed), 1)
                      ]))
                    }), 128))
                  ])
                ], 64))
          ]),
          _: 2
        }, [
          (_ctx.isImporting)
            ? {
                name: "footer",
                fn: _withId(() => [
                  _createVNode("div", _hoisted_13, [
                    _createVNode("div", null, [
                      _createVNode(_component_el_button, {
                        class: "margin-right10px",
                        onClick: _ctx.choose
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextChooseAFile), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode("label", _hoisted_14, _toDisplayString(_ctx.fileName), 1)
                    ]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _ctx.submit,
                      disabled: _ctx.fileName === ''
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.$wordList.RDeiviceImport), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled"])
                  ])
                ])
              }
            : undefined
        ]), 1032, ["title", "onClose"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", _hoisted_15, [
      _createVNode("div", null, [
        (_ctx.step == 0)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _hoisted_16,
              _hoisted_17,
              _createVNode("label", _hoisted_18, _toDisplayString(_ctx.percent), 1)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.step == 1)
          ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _createVNode("img", {
                src: require('@/assets/image/import.gif')
              }, null, 8, ["src"]),
              _hoisted_19,
              _createVNode("label", _hoisted_20, _toDisplayString(_ctx.percent), 1)
            ], 64))
          : _createCommentVNode("", true)
      ])
    ], 512), [
      [_vShow, _ctx.isShowLoading]
    ]),
    _createVNode("input", _hoisted_21, null, 512),
    (_ctx.isShowFaceRecognitionEnrollmentDialog)
      ? (_openBlock(), _createBlock(_component_face_recognition_enrollment_dialog, {
          key: 1,
          onClose: _ctx.cancelFaceRecognitionEnrollment,
          onAllow: _ctx.allowFaceRecognitionEnrollment
        }, null, 8, ["onClose", "onAllow"]))
      : _createCommentVNode("", true)
  ]))
})